import phone_logo from "../images/phone_logo.webp";

const userData = {
  validChars: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace", "ArrowLeft", "ArrowRight", "Delete"],
  extensions: [{label: "India", phone: "+91"}],
  phoneImg: phone_logo,
};

export default userData;
